export const FACE_PAY_BO_V2 = "FACE_PAY_BO_V2"

export const FACE_PAY_BO_V2_LOGIN = "FACE_PAY_BO_V2_LOGIN"